<div class="error-page">
  <div class="error-header">
    <img src="assets/images/logos/nexus-d.png" alt="Logo" class="logo" />
  </div>

  <div class="error-card flex flex-column align-items-start">
    <div class="error-card-header">
      <h1 class="text-2xl font-bold" style="color: #0f2765">
        {{ errorMessage }}
      </h1>
      <img src="assets/images/logos/mi-icon-logo-dark.png" alt="Logo" class="logo" width="25" />
    </div>
    <p class="text-sm text-gray-500 mt-2">Código de error: {{ errorCode }}</p>

    <div class="w-full">
    </div>
    <div class="w-full">
      <p class="text-lg" style="color: #0f2765">
        {{ errorDetails }}
      </p>
    </div>
    <button miButton="primary" class="w-full" (click)="toLogin()">Ir al inicio</button>
  </div>
  <div class="error-footer">
    <span class="text-xs">© 2025 Misión Empresarial. Todos los derechos reservados.</span>
  </div>
</div>
